//时间格式化

//输出年月日 yyyy-dd-mm time为字符串2001-10-10 12:00:00
export function getYyyyddmm(time) {
    if(time!==null && typeof(time)!=="undefined" && time!==""){
        return time.split(" ")[0];
    }else{
        return "";
    }
}